/* Start Stop Win — how-to video lightbox.
   Click any [data-ssw-video] element to open its video in an overlay.
   Video docs are lazy-loaded from window.SSW_VIDEO_SRC[key] (asset URLs)
   and mounted into an iframe via srcdoc. */
(function(){
  if (window.__sswLightbox) return;
  window.__sswLightbox = 1;
  var overlay, frame, titleEl, loadEl, injected = {};

  function build(){
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.setAttribute('role','dialog');
    overlay.setAttribute('aria-modal','true');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(8,12,20,.82);backdrop-filter:blur(3px)';
    overlay.innerHTML =
      '<div style="position:relative;width:min(980px,100%);display:flex;flex-direction:column;background:#0A1420;border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.55)">'
      + '<div style="display:flex;align-items:center;gap:8px;padding:11px 15px;background:#101216">'
      +   '<span style="width:11px;height:11px;border-radius:50%;background:#FF3B1F"></span>'
      +   '<span style="width:11px;height:11px;border-radius:50%;background:#FFC400"></span>'
      +   '<span style="width:11px;height:11px;border-radius:50%;background:#3ecf6b"></span>'
      +   '<span data-lb-title style="font:600 13px Barlow,sans-serif;color:rgba(255,255,255,.72);margin-left:6px"></span>'
      +   '<button data-lb-x aria-label="Close video" style="margin-left:auto;width:30px;height:30px;border:0;border-radius:8px;background:rgba(255,255,255,.12);color:#fff;font-size:20px;line-height:1;cursor:pointer">&times;</button>'
      + '</div>'
      + '<div style="position:relative;background:#0A1420">'
      +   '<div data-lb-load style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.6);font:600 14px Barlow,sans-serif">Loading video…</div>'
      +   '<iframe data-lb-frame title="How-to video" allow="autoplay" style="display:block;width:100%;height:min(70vh,600px);border:0;background:#0A1420"></iframe>'
      + '</div>'
      + '</div>';
    document.body.appendChild(overlay);
    frame = overlay.querySelector('[data-lb-frame]');
    titleEl = overlay.querySelector('[data-lb-title]');
    loadEl = overlay.querySelector('[data-lb-load]');
    overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
    overlay.querySelector('[data-lb-x]').addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && overlay.style.display !== 'none') close(); });
  }

  function whenReady(key, cb){
    if (window.SSWV && window.SSWV[key]) return cb();
    function h(e){ if (e.detail === key){ window.removeEventListener('ssw-video-ready', h); cb(); } }
    window.addEventListener('ssw-video-ready', h);
    if (!injected[key]){
      injected[key] = true;
      var src = (window.SSW_VIDEO_SRC || {})[key];
      if (!src){ console.warn('[ssw-lightbox] no source registered for', key); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onerror = function(){ console.error('[ssw-lightbox] failed to load', key, src); loadEl.textContent = 'Could not load this video.'; };
      document.head.appendChild(s);
    }
  }

  function open(key, title){
    build();
    titleEl.textContent = title || 'How-to';
    loadEl.textContent = 'Loading video…';
    loadEl.style.display = 'flex';
    frame.removeAttribute('srcdoc');
    overlay.style.display = 'flex';
    document.documentElement.style.overflow = 'hidden';
    whenReady(key, function(){
      frame.onload = function(){ loadEl.style.display = 'none'; };
      frame.srcdoc = window.SSWV[key];
    });
  }

  function close(){
    if (!overlay) return;
    overlay.style.display = 'none';
    document.documentElement.style.overflow = '';
    frame.srcdoc = '';           // tear down = stop playback + audio
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-ssw-video]') : null;
    if (!t) return;
    var key = t.getAttribute('data-ssw-video');
    if (!key) return;
    e.preventDefault();
    var title = t.getAttribute('data-ssw-video-title');
    if (!title){ var h3 = t.querySelector('.h3'); title = h3 ? h3.textContent : ''; }
    open(key, title);
  });
})();
